import { render, staticRenderFns } from "./TeamListContent.vue?vue&type=template&id=1b32bc27&"
import script from "./TeamListContent.vue?vue&type=script&lang=js&"
export * from "./TeamListContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports